import { useEffect, useState } from 'react'

import { actions as builderActions } from '../../../../tradebuilder-v2/modules/00-builder/state/builder-slice'
import { useAppDispatch, useAppSelector } from '../../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../../tradebuilder-v2/store/use-actions'
import {
  actions as setEconomicsActions,
  postTradeApprove,
  SetEconomicsFormState
} from '../state/set-economics-slice'
import SetEconomicsStateless from '../templates/set-economics-stateless'

const SetEconomics = () => {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.setEconomics)
  const actions = useActions(setEconomicsActions)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useAppDispatch()

  const onTradeApprove = (formState: SetEconomicsFormState) => {
    dispatch(postTradeApprove(builderState.accountId, formState))
  }

  useEffect(() => {
    setIsLoading(true)
    actions.reset()
    actions.initialise({
      savedState: builderState.savedState,
      userName: builderState.userName,
      userType: builderState.userType,
      userRoles: builderState.userRoles,
      approvalEvents: builderState.approvalEvents,
      status: builderState.status
    })
  }, [
    builderState.savedState,
    builderState.approvalEvents,
    actions,
    builderState.userName,
    builderState.userType,
    builderState.userRoles,
    builderState.status
  ])
  useEffect(() => {
    setIsLoading(false)
  }, [state])
  useEffect(() => {
    if (state.accountId === builderState.selectedAccountId && state.success === true) {
      dispatch(
        builderActions.refreshTradeStatus(state.accountId, {
          title: 'The trade economics have been approved'
        })
      )
    }
  }, [
    builderState.selectedAccountId,
    state.accountId,
    builderState.status,
    dispatch,
    state.success
  ])

  if (!isLoading) {
    return (
      <SetEconomicsStateless
        state={state}
        onSetValid={actions.setValid}
        onTradeApprove={onTradeApprove}
      />
    )
  }

  return null
}

export default SetEconomics
